import React, { useState } from 'react';

function CardForm() {
  const [cardData, setCardData] = useState({
    name: '',
    number: '',
    expMonth: '',
    expYear: '',
    cvc: '',
  });

  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCardData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        'https://finix.sandbox-payments-api.com/tokens',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.finix.token.v1+json',
          },
          body: JSON.stringify({
            type: 'TOKEN',
            card: {
              number: cardData.number,
              expiration_month: cardData.expMonth,
              expiration_year: cardData.expYear,
              security_code: cardData.cvc,
              name: cardData.name,
            },
          }),
        }
      );

      const result = await response.json();

      if (result.id) {
        setToken(result.id);
        setError(null);
      } else {
        throw new Error(result.message || 'Tokenization failed');
      }
    } catch (err) {
      setError(err.message);
      setToken(null);
    }
  };

  return (
    <div>
      <h2>Enter Card Info</h2>
      <input
        name="name"
        placeholder="Cardholder Name"
        onChange={handleChange}
      />
      <input name="number" placeholder="Card Number" onChange={handleChange} />
      <input
        name="expMonth"
        placeholder="Expiration Month (MM)"
        onChange={handleChange}
      />
      <input
        name="expYear"
        placeholder="Expiration Year (YYYY)"
        onChange={handleChange}
      />
      <input name="cvc" placeholder="CVC" onChange={handleChange} />
      <button onClick={handleSubmit}>Tokenize Card</button>

      {token && <p>✅ Token ID: {token}</p>}
      {error && <p style={{ color: 'red' }}>❌ Error: {error}</p>}
    </div>
  );
}

export default CardForm;
